
    import { Component, Vue } from 'vue-property-decorator';
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
    import Patientengruppe from '@/types/Patientengruppe';
    import { DataTableHeaders} from '@/types';
    import { SystemEinstellung, SystemEinstellungKey } from '@/types/Einstellung';

    @Component({
        computed: {
            ...mapState('patientengruppen', ['gruppen', 'dialogs', 'loaders']),
            ...mapGetters('authentication', ['getSystemEinstellung']),
        },
        methods: {
            ...mapActions('patientengruppen', ['loadPatientengruppen']),
            ...mapMutations('patientengruppen', ['setDialogsDetail']),
        },
    })
    export default class Patientengruppen extends Vue {
        public patientengruppe = new Patientengruppe();
        public search = '';

        public loadPatientengruppen!: () => void;
        public getSystemEinstellung!: <T>(parameter: SystemEinstellungKey) => SystemEinstellung<T>;

        public get headers(): DataTableHeaders<Patientengruppe> {
            return [
                { text: '', value: 'actions', sortable: false, width: 50 },
                { text: 'Patientengruppe ID', value: 'patientengruppe_id' },
                { text: 'Patientengruppe', value: 'patientengruppe' },
                { text: 'Gültig', value: 'gueltig' },
            ].filter((header) => header) as DataTableHeaders<Patientengruppe>;
        }

        public mounted(): void {
            this.loadPatientengruppen();
        }
    }
